// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropShadow[data-v-33d29e5c]{box-shadow:0 2px 4px #fbeae9;-webkit-box-shadow:0 2px 4px#FBEAE9;-moz-box-shadow:0 2px 4px #fbeae9}.headerText[data-v-33d29e5c]{font-size:1.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
